module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFiltersWidgetImages":{"image_alt":"Ikona pro hodnotu {value}"}},"de":{"CatalogFiltersWidgetImages":{"image_alt":"Symbol für {value}"}},"sk":{"CatalogFiltersWidgetImages":{"image_alt":"Ikona pro hodnotu {value}"}}}')
  delete Component.options._Ctor
}
